import OnboardingBanner from "../../common/onboarding-banner/OnboardingBanner.tsx";
import { FormattedDate } from "react-intl";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import SocialChatLine from "../../../../common/icons/SocialChatLine.tsx";
import useVirtualStoreServiceAnnouncement, {
  getServiceAnnouncementDateWithTimeZone,
} from "../../common/virtual-store/useVirtualStoreServiceAnnouncement.ts";
import ServiceAnnouncementBannerBody from "../../common/virtual-store/ServiceAnnouncementBannerBody.tsx";

/**
 * @see VirtualStoreSystemMessage
 */
export default function ServiceAnnouncementBanner() {
  const { VirtualStore } = useBrandLoaderData();

  const [shouldShow, onDismiss] = useVirtualStoreServiceAnnouncement();

  if (!shouldShow) {
    return null;
  }

  const startDate = getServiceAnnouncementDateWithTimeZone(
    VirtualStore.ServiceAnnouncement.startDate!
  );

  return (
    <OnboardingBanner
      noMargin
      icon={<SocialChatLine />}
      badgeText={<FormattedDate value={startDate} dateStyle="long" />}
      badgeStyle="plain"
      title={VirtualStore.ServiceAnnouncement.title!}
      body={
        <ServiceAnnouncementBannerBody
          body={VirtualStore.ServiceAnnouncement.body}
        />
      }
      onClose={onDismiss}
    />
  );
}
